// KlarenEnding.jsx — cinematic 'movie-title' ending section.
// The KLAREN wordmark resolves onto a dark theatre screen, letter by letter.
import React, { useEffect, useRef } from "react";
import { Btn } from "./Primitives";

export default function KlarenEnding({ onShop }) {
  const ref = useRef(null);
  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    if (typeof IntersectionObserver === "undefined") { el.classList.add("in"); return; }
    const io = new IntersectionObserver(
      (entries) => entries.forEach((e) => { if (e.isIntersecting) { el.classList.add("in"); io.unobserve(e.target); } }),
      { threshold: 0.35 }
    );
    io.observe(el);
    return () => io.disconnect();
  }, []);
  const letters = ["K", "L", "A", "R", "E", "N"];
  return (
    <section ref={ref} className="k-ending" data-testid="klaren-ending">
      <span className="k-spot" />
      <div style={{ position: "relative", zIndex: 2 }}>
        <span className="k-eye" style={{ color: "rgba(246,241,232,.5)", display: "block", marginBottom: "clamp(22px,4.5vh,44px)", letterSpacing: ".42em" }}>Now showing — in every home</span>
        <div className="k-bigword" aria-label="Klaren">
          {letters.map((ch, i) => (
            <span key={i} style={{ transitionDelay: `${0.2 + i * 0.13}s` }}>{ch}</span>
          ))}
        </div>
        <div className="k-line" />
        <p style={{ color: "rgba(246,241,232,.6)", marginTop: "clamp(22px,4vh,34px)", fontSize: 15, letterSpacing: ".02em", lineHeight: 1.6 }}>
          Skin-kind home care — for everything you touch.
        </p>
        <div style={{ marginTop: 30, display: "flex", justifyContent: "center" }}>
          <Btn variant="light" size="lg" icon="arrow-right" onClick={onShop} testId="ending-shop-btn">Enter the range</Btn>
        </div>
      </div>
    </section>
  );
}
